export default __webpack_public_path__ + "static/media/classic02.080807af.png";